import Vue from "vue";
import VueRouter from "vue-router";
import Reciepe from "../views/Reciepe.vue";
import ReciepeList from "../views/ReciepeList.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Reciepe List",
    component: ReciepeList
  },
  {
    path: "/reciepe/:reciepe_id",
    name: "Reciepe Details",
    component: Reciepe
  }
];

const router = new VueRouter({
  mode: "history",
  //base: process.env.BASE_URL,
  routes
});

export default router;
